const config = {
  ...window.config,
};
export default config;
